import { useEffect, useState, useContext } from 'react';
import { useForm } from "react-hook-form";

import * as Regex from 'utils/validations';
import { DataContext } from 'providers/data';
import { DataTypesOfContact } from 'core/typesOfContact';
import { ParamsDataCustomerForEdit } from 'utils/typeServices';

import { Box, Typography, Collapse } from '@mui/material';

import Modals from 'components/views/Modals';
import Input from 'components/views/form/Input';
import Select from 'components/views/form/Select';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';

import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

type ParamsCustomerForEdit = {
    dataCustomerForEdit: ParamsDataCustomerForEdit;
}

const PhoneContact = ({ dataCustomerForEdit }: ParamsCustomerForEdit) => {
    const [isLoading, setIsLoading] = useState(false);
    const [addContact, setAddContact] = useState(false);
    const [isEnableBtn, setIsEnableBtn] = useState(false);
    const [isEditInfos, setIsEditInfos] = useState(false);
    const [lengthDelete, setLengthDelete] = useState(0);
    const [reload, setReload] = useState(true);
    const [showAddContact, setShowAddContact] = useState(false);
    const [showModalDeleted, setShowModalDeleted] = useState(false);
    const [indexDeleted, setIndexDeleted] = useState(0);

    const [typeSelected, setTypeSelected] = useState({
        text: '',
        value: ''
    });

    const handlePlaceholderPhone = (typePhone: number) => {
        if ((typePhone === 3) || (typePhone === 7)) {
            return '(99) 99999-9999';
        } else {
            return '(99) 9999-9999';
        }
    }

    const { updatePerfil, handlePostEditCustomerAppPhone } = useContext(DataContext);
    const { register, setValue, watch } = useForm();

    const phoneAdd = watch('phoneAdd', '');

    const handleCheckType = (type: number) => {
        switch (type) {
            case 1:
                return {
                    text: 'COMERCIAL',
                    value: '1'
                }
            case 2:
                return {
                    text: 'RESIDENCIAL',
                    value: '2'
                }
            case 3:
                return {
                    text: 'CELULAR',
                    value: '3'
                }
            case 7:
                return {
                    text: 'WHATSAPP',
                    value: '7'
                }
        }
    }

    const handleClickBtnCancel = () => {
        setIsEditInfos(!isEditInfos);
        setAddContact(false);

        if (isEditInfos) {
            setReload(false);

            setTimeout(() => {
                dataCustomerForEdit.phoneList.map(({ deleted }, index) => (
                    setValue(`deleted${index}`, deleted)
                ));
                setLengthDelete(dataCustomerForEdit.phoneList.length);
            }, 150);

            setTimeout(() => {
                setReload(true);
            }, 500);
        }
    }

    const handlePostEditCustomerAppPhoneState = () => {
        setIsLoading(true);

        let phoneListAux = dataCustomerForEdit.phoneList.map(({ customerPhoneId }, index) => {
            return {
                phoneTypeId: parseFloat(watch(`typePhone${index}[value]`)),
                deleted: watch(`deleted${index}`),
                customerPhoneId,
                number: watch(`phone${index}`).replace(/[^0-9]/g, '')?.slice(2, 20),
                phoneDDD: watch(`phone${index}`).replace(/[^0-9]/g, '')?.slice(0, 2),
            };
        })

        addContact && phoneListAux.push({
            phoneDDD: phoneAdd.replace(/[^0-9]/g, '')?.slice(0, 2),
            number: phoneAdd.replace(/[^0-9]/g, '')?.slice(2, 20),
            phoneTypeId: parseFloat(typeSelected?.value),
            deleted: false,
            customerPhoneId: 0,
        });

        handlePostEditCustomerAppPhone({
            token: localStorage.getItem('token')!,
            body: {
                id: dataCustomerForEdit.id,
                phoneList: phoneListAux
            }
        });
    }

    useEffect(() => {
        if (dataCustomerForEdit) {
            dataCustomerForEdit.phoneList.map(({ phoneDDD, number, phoneTypeId, deleted }, index) => (
                // eslint-disable-next-line no-sequences
                setValue(`phone${index}`, `(${phoneDDD}) ${number?.slice(0, 5)}-${number?.slice(5, 9)}`),
                setValue(`typePhone${index}`, handleCheckType(phoneTypeId)),
                setValue(`deleted${index}`, deleted)
            ));
            setIsLoading(false);
            setAddContact(false);
            setIsEditInfos(false);
            setLengthDelete(dataCustomerForEdit.phoneList.length);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataCustomerForEdit]);

    useEffect(() => {
        setTimeout(() => {
            setShowAddContact(addContact);
        }, 550);
        setValue('phoneAdd', '');
        setTypeSelected({ text: '', value: '' });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addContact]);

    useEffect(() => {
        if (addContact && phoneAdd.match(Regex.phone) && typeSelected.value) {
            setIsEnableBtn(false);
        } else if (addContact) {
            setIsEnableBtn(true);
        } else {
            setIsEnableBtn(false);
        }
    }, [addContact, phoneAdd, typeSelected.value]);

    useEffect(() => {
        if (updatePerfil?.type !== 'default') {
            handleClickBtnCancel();
            setIsLoading(false);
            setAddContact(false);
            setIsEditInfos(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updatePerfil]);

    return (
        <Box sx={{ width: '100%' }}>
            <Collapse in={addContact ? showAddContact : addContact}>
                <Typography fontWeight={600} fontSize='1.25rem' color='primary.light' sx={{ marginBottom: { xs: '1.3175rem', md: '2.125rem' } }}>
                    Novo contato:
                </Typography>
            </Collapse>
            <Collapse in={!addContact ? !showAddContact : !addContact}>
                <Typography fontSize='.875rem' sx={{ fontWeight: { xs: '400', md: '600' }, marginBottom: { xs: '1.3175rem', md: '2.125rem' } }}>
                    Para a sua segurança é importante ao menos 2 (dois) telefones (fixo e celular) para contato.
                </Typography>
            </Collapse>

            <Box sx={{ display: 'flex', gap: '.75rem', borderBottom: '1px solid rgba(141, 155, 181, 0.5)', marginBottom: '1rem', paddingBottom: '4px', width: { xs: '100%', md: 'fit-content' } }}>
                <Typography fontSize='.8125rem' sx={{ width: { xs: 'calc(50% - .375rem)', md: '18.93rem' } }}>
                    Tipo
                </Typography>
                <Typography fontSize='.8125rem' sx={{ width: { xs: 'calc(50% - .375rem)', md: '18.93rem' } }}>
                    Telefone
                </Typography>
            </Box>

            <Collapse in={addContact ? showAddContact : addContact}>
                <Box sx={{ display: 'flex', marginBottom: '1.5625rem', maxWidth: '31.12rem', justifyContent: 'space-between', '#box-input': { height: 'fit-content' }, gap: { xs: '.75rem', md: '1rem' } }}>
                    <Select
                        disabled={!isEditInfos}
                        itemSelected={typeSelected}
                        listItems={DataTypesOfContact.map(({ phoneTypeText, phoneTypeId }) => {
                            return { text: phoneTypeText, value: `${phoneTypeId}` }
                        })}
                        onChangeSelected={(e) => setTypeSelected(e)}
                    />
                    <Input
                        name='phoneAdd'
                        placeholder={handlePlaceholderPhone(parseFloat(typeSelected.value))}
                        maskHolder={handlePlaceholderPhone(parseFloat(typeSelected.value))}
                        type='tel'
                        mask
                        register={{ ...register('phoneAdd', { pattern: /^[0-9]{1}$/i }) }}
                    />
                </Box>
            </Collapse>

            <Collapse in={!addContact ? (reload && !showAddContact) : !addContact}>
                {dataCustomerForEdit?.phoneList?.map(({ deleted, phoneTypeId }, index) => (
                    !watch(`deleted${index}`) &&
                    <Box key={index} sx={{ display: 'flex', width: '100%', justifyContent: 'flex-start' }}>
                        <Box sx={{ display: 'flex', marginBottom: '1.5625rem', width: '100%', maxWidth: '31.12rem', justifyContent: 'space-between', '#box-input': { height: 'fit-content' }, gap: { xs: '.75rem', md: '1rem' } }}>
                            <Select
                                disabled={!isEditInfos}
                                itemSelected={watch(`typePhone${index}`)}
                                listItems={DataTypesOfContact.map(({ phoneTypeText, phoneTypeId }) => {
                                    return { text: phoneTypeText, value: `${phoneTypeId}` }
                                })}
                                onChangeSelected={(e) => setValue(`typePhone${index}`, e)}
                            />
                            <Input
                                name={`phone${index}`}
                                placeholder={handlePlaceholderPhone(parseFloat(watch(`typePhone${index}[value]`)))}
                                maskHolder={handlePlaceholderPhone(parseFloat(watch(`typePhone${index}[value]`)))}
                                disabled={!isEditInfos}
                                type='tel'
                                mask
                                register={{ ...register(`phone${index}`, { pattern: /^[0-9]{1}$/i }) }}
                            />
                        </Box>
                        {lengthDelete > 1 && isEditInfos &&
                            <Box sx={{
                                cursor: 'pointer',
                                marginLeft: '2rem',
                                width: '2.5rem',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '2.5rem',
                                borderRadius: '100px',
                                backgroundColor: 'error.main'
                            }}
                                onClick={() => {
                                    setShowModalDeleted(true);
                                    setIndexDeleted(index);
                                }}
                            >
                                <DeleteForeverOutlinedIcon sx={{ color: 'white' }} />
                            </Box>
                        }
                    </Box>
                ))}
            </Collapse>

            <Box sx={{ display: 'flex', gap: '1rem', 'button': { height: '2.5rem', width: '100%', maxWidth: { xs: '100%', md: '15.06rem' } } }}>
                <ButtonOutlined
                    name={isEditInfos ? 'CANCELAR' : 'Editar'}
                    onClick={() => handleClickBtnCancel()} />
                <ButtonRectangle loadingBtn={isLoading} disabled={isEnableBtn} name={isEditInfos ? 'SALVAR DADOS' : 'ADICIONAR'} onClick={() => !isEditInfos ? (setAddContact(true), setIsEditInfos(true)) : handlePostEditCustomerAppPhoneState()} />
            </Box>

            <Modals open={showModalDeleted}>
                <Box sx={{ textAlign: 'center', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '20rem' } }}>
                    <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 1.375rem 1.25rem'>
                        <Typography fontSize='1.5625rem' fontWeight={700} lineHeight='30px'>
                            ATENÇÃO!
                        </Typography>
                        <Typography fontSize='1rem' lineHeight='20px' marginTop='.5rem'>
                            Deseja remover este contato?
                        </Typography>
                    </Box>

                    <Box sx={{
                        backgroundColor: 'primary.main',
                        borderRadius: '0 0 8px 8px',
                        padding: {
                            xs: '1rem 2.5rem 1.625rem',
                            md: '1.875rem 2rem 1.625rem'
                        },
                        'button': {
                            width: '12.5rem',
                            height: '2.5rem'
                        }
                    }}>
                        <ButtonRectangle name='DELETAR' onClick={() => {
                            setValue(`deleted${indexDeleted}`, true);
                            setLengthDelete(lengthDelete - 1);
                            setShowModalDeleted(false);
                        }} />
                        <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                            <ButtonOutlined name='CANCELAR' onClick={() => setShowModalDeleted(false)} />
                        </Box>
                    </Box>
                </Box>
            </Modals>
        </Box>
    );
}

export default PhoneContact;